import type { LicenceStatsResponse } from '@shared/schemas';

import { emptyClientCategories } from '../../_shared/domain/licence-client-categories';
import { emptyCsmCandidates } from '../../_shared/domain/licence-csm';
import type {
  LicenceEditState,
  LicenceMutation,
  LicenceResponse,
  LicencesError,
  LoadStatus,
} from '../domain/licence.model';

/**
 * Redux state for the Licences admin index: the loaded rows, the load lifecycle,
 * the last load error, the KPI-band figures (a separate fetch, so `null` until
 * they land), and the lifecycle of the one write a row's actions menu may have in
 * flight. Every field is serialisable so the whole slice can be persisted /
 * replayed.
 */
export interface LicencesState {
  rows: LicenceResponse[];
  loadStatus: LoadStatus;
  error: LicencesError | null;
  stats: LicenceStatsResponse | null;
  mutation: LicenceMutation;
  edit: LicenceEditState;
}

export const closedEdit: LicenceEditState = {
  licenceId: null,
  licence: null,
  licenceStatus: 'idle',
  csmCandidates: emptyCsmCandidates,
  clientCategories: emptyClientCategories,
  save: { status: 'idle', error: null },
};

export const idleMutation: LicenceMutation = {
  kind: null,
  status: 'idle',
  error: null,
  revokedSessions: 0,
};

export const initialState: LicencesState = {
  rows: [],
  loadStatus: 'idle',
  error: null,
  stats: null,
  mutation: idleMutation,
  edit: closedEdit,
};
